// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2d-S5","right":"styles_right__3hNR2"};